import { Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'loading',
  template: `<div class="preloader" [ngClass]="fullscreen? 'fullscreen' : ''" *ngIf="active">
                <div class="spinner-border" [ngClass]="color? color : 'text-primary'">
                  <span class="sr-only">Carregando...</span>
                </div>
              </div>`,
  styleUrls: ['./loading.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoadingComponent implements OnDestroy {

  @Input() public backgroundColor = 'rgba(0, 150, 136, 0.69)';
  @Input() public active = true;
  @Input() public color = false;
  @Input() public fullscreen = true;

  constructor() { }

  ngOnDestroy(): void {
    this.active = false;
  }
}
